export const CREATE_TYPIFICATION_ATTEMPTED = 'OVID/TYPIFICATIONS/CREATE'
export const CREATE_TYPIFICATION_SUCCEEDED = 'OVID/TYPIFICATIONS/CREATED'
export const CREATE_TYPIFICATION_FAILED = 'OVID/TYPIFICATIONS/CREATE_FAILED'

export const CLEAR_TYPIFICATION_ERROR = 'OVID/TYPIFICATIONS/CLEAR_ERROR'
